<template>
  <div class="IndexBox" style="padding-top: 0;">
    <div class="ScrollBox UserInfo">
      <van-nav-bar
        :border="false"
        :left-text="$t('user.default[0]')"
        @click-right="$Model.Logout()"
      >
        <template #right>
          <van-icon :name="`./static/icon/${Theme}/icon-logout.png`" size="18" />
        </template>
      </van-nav-bar>
      <div class="top">
        <van-cell class="info" :border="false" is-link :clickable="false" to="/user/info">
          <template #icon>
            <img class="head" :src="`./static/head/${UserInfo.header}`" width="58" height="58">
          </template>
          <template #title>
            <div style="display:flex;align-items:center">
              {{showName?UserInfo.username:'******'}}
              <van-icon :name="showName?'eye':'closed-eye'" size="18" style="margin-left: 3px" @click.stop="showName=!showName" />
              <span>{{UserInfo.useridentity}}</span>
            </div>
          </template>
          <template #label>
            {{$t('user.default[2]')}}: {{UserInfo.idcode}}
            <p v-if="UserInfo.susername">{{$t('user.default[11]')}}: {{UserInfo.susername}}</p>
          </template>
        </van-cell>
        <div :class="`steps step${UserInfo.credit>80?3:UserInfo.credit>50&&UserInfo.credit<81?2:UserInfo.credit>0&&UserInfo.credit<51?1:0}`">
          <span class="mark">{{UserInfo.credit>80?$t('user.default[10]'):UserInfo.credit>50&&UserInfo.credit<81?$t('user.default[9]'):UserInfo.credit>0&&UserInfo.credit<51?$t('user.default[8]'):$t('user.default[7]')}}</span>
          <div class="bg">
            <i v-for="item,index in 4" :key="index" :class="{active: index<=(UserInfo.credit>80?3:UserInfo.credit>50&&UserInfo.credit<81?2:UserInfo.credit>0&&UserInfo.credit<51?1:0)}"></i>
            <span class="portion"></span>
          </div>
        </div>
        <div class="user-balance">
          <div class="bg">
            <div class="left">
              <p>{{$t('user.grid[0]')}}({{InitData.currency}})</p>
              {{$Util.MoneyFormat(UserInfo.balance)}}
            </div>
            <div class="right">
              <van-button color="var(--button-main)" plain round size="small" style="border:0;padding:0 15px;" to="/user/wallet">{{$t('user.default[6]')}}</van-button>
            </div>
          </div>
          <div class="line"></div>
        </div>
      </div>
      <div style="padding:12px">
        <div class="total">
          <van-grid class="top" column-num="3" :border="false">
            <van-grid-item>
              <template #icon>
                {{$t('user.grid[2]')}}({{InitData.currency}})
              </template>
              <template #text>
                {{$Util.MoneyFormat(StatisticalData.today_total_profit)}}
              </template>
            </van-grid-item>
            <van-grid-item>
              <template #icon>
                {{$t('user.grid[6]')}}({{InitData.currency}})
              </template>
              <template #text>
                {{$Util.MoneyFormat(StatisticalData.total_profit)}}
              </template>
            </van-grid-item>
            <van-grid-item>
              <template #icon>
                {{$t('user.grid[7]')}}
              </template>
              <template #text>
                {{StatisticalData.day_number}}/{{StatisticalData.my_day_number}}
              </template>
            </van-grid-item>
          </van-grid>
          <a class="more" href="javascript:;" @click="showMoreTotal=!showMoreTotal">
            <van-icon :name="showMoreTotal?'arrow-up':'arrow-down'" size="18" color="var(--color-assist)" />
          </a>
          <div v-show="showMoreTotal" class="bottom">
            <table width="100%">
              <thead>
                <tr>
                  <td></td>
                  <td>{{$t('user.grid[12][0]')}}</td>
                  <td>{{$t('user.grid[12][1]')}}</td>
                  <td v-if="InitData.setting.is_crowdfunding==1">{{$t('user.grid[12][2]')}}</td>
                  <td v-if="InitData.setting.is_invest==1">{{$t('user.grid[12][3]')}}</td>
                  <td v-if="InitData.setting.is_invest==1">{{$t('user.grid[12][4]')}}</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{$t('user.grid[11][0]')}}</td>
                  <td><b>{{$Util.MoneyFormat(StatisticalData.today_earnings)}}</b></td>
                  <td><b>{{$Util.MoneyFormat(StatisticalData.today_earnings_proxy)}}</b></td>
                  <td v-if="InitData.setting.is_crowdfunding==1"><b>{{$Util.MoneyFormat(StatisticalData.c_today_earnings)}}</b></td>
                  <td v-if="InitData.setting.is_invest==1"><b>{{$Util.MoneyFormat(StatisticalData.t_today_earnings)}}</b></td>
                  <td v-if="InitData.setting.is_invest==1"><b>{{$Util.MoneyFormat(StatisticalData.ty_today_earnings)}}</b></td>
                </tr>
                <tr>
                  <td>{{$t('user.grid[11][1]')}}</td>
                  <td><b>{{$Util.MoneyFormat(StatisticalData.yesterday_earnings)}}</b></td>
                  <td><b>{{$Util.MoneyFormat(StatisticalData.yesterday_earnings_proxy)}}</b></td>
                  <td v-if="InitData.setting.is_crowdfunding==1"><b>{{$Util.MoneyFormat(StatisticalData.c_yesterday_earnings)}}</b></td>
                  <td v-if="InitData.setting.is_invest==1"><b>{{$Util.MoneyFormat(StatisticalData.t_yesterday_earnings)}}</b></td>
                  <td v-if="InitData.setting.is_invest==1"><b>{{$Util.MoneyFormat(StatisticalData.ty_yesterday_earnings)}}</b></td>
                </tr>
                <tr>
                  <td>{{$t('user.grid[11][2]')}}</td>
                  <td><b>{{$Util.MoneyFormat(StatisticalData.week_earnings)}}</b></td>
                  <td><b>{{$Util.MoneyFormat(StatisticalData.week_earnings_proxy)}}</b></td>
                  <td v-if="InitData.setting.is_crowdfunding==1"><b>{{$Util.MoneyFormat(StatisticalData.c_week_earnings)}}</b></td>
                  <td v-if="InitData.setting.is_invest==1"><b>{{$Util.MoneyFormat(StatisticalData.t_week_earnings)}}</b></td>
                  <td v-if="InitData.setting.is_invest==1"><b>{{$Util.MoneyFormat(StatisticalData.ty_week_earnings)}}</b></td>
                </tr>
                <tr>
                  <td>{{$t('user.grid[11][3]')}}</td>
                  <td><b>{{$Util.MoneyFormat(StatisticalData.month_earnings)}}</b></td>
                  <td><b>{{$Util.MoneyFormat(StatisticalData.month_earnings_proxy)}}</b></td>
                  <td v-if="InitData.setting.is_crowdfunding==1"><b>{{$Util.MoneyFormat(StatisticalData.c_month_earnings)}}</b></td>
                  <td v-if="InitData.setting.is_invest==1"><b>{{$Util.MoneyFormat(StatisticalData.t_month_earnings)}}</b></td>
                  <td v-if="InitData.setting.is_invest==1"><b>{{$Util.MoneyFormat(StatisticalData.ty_month_earnings)}}</b></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="total" style="margin-top: 15px;">
          <van-grid class="top" column-num="3" :border="false">
            <div style="width:100%;padding:8px 8px 0;text-align:center;">{{$t('teamReport.default[22]')}}</div>
            <van-grid-item>
              <template #icon>
                {{$t('user.grid[14][0]')}}
              </template>
              <template #text>
                {{StatisticalData.today_efficientNum}}
              </template>
            </van-grid-item>
            <van-grid-item>
              <template #icon>
                {{$t('user.grid[14][1]')}}
              </template>
              <template #text>
                {{StatisticalData.yesterday_efficientNum}}
              </template>
            </van-grid-item>
            <van-grid-item>
              <template #icon>
                {{$t('user.grid[14][2]')}}
              </template>
              <template #text>
                {{StatisticalData.threeday_efficientNum}}
              </template>
            </van-grid-item>
          </van-grid>
        </div>
        <div v-if="UserInfo.is_admin==1" class="total" style="margin-top: 15px;">
          <van-grid class="top" column-num="3" :border="false">
            <van-grid-item>
              <template #icon>
                {{$t('user.grid[13][0]')}}
              </template>
              <template #text>
                {{StatisticalData.this_week_number}}
              </template>
            </van-grid-item>
            <van-grid-item>
              <template #icon>
                {{$t('user.grid[13][1]')}}
              </template>
              <template #text>
                {{StatisticalData.this_week_valid_number}}
              </template>
            </van-grid-item>
            <van-grid-item>
              <template #icon>
                {{$t('user.grid[13][2]')}}({{InitData.currency}})
              </template>
              <template #text>
                {{$Util.MoneyFormat(StatisticalData.total_spread)}}
              </template>
            </van-grid-item>
          </van-grid>
        </div>
        <!-- <div class="group">
          <div class="title">{{$t('user.title[0]')}}</div>
          <van-grid class="menu" :border="false" column-num="3" icon-size="30">
            <van-grid-item :icon="`./static/icon/${Theme}/icon-menu1.png`" :text="$t('user.menu[0]')" to="/user/taskOrder" />
            <van-grid-item :icon="`./static/icon/${Theme}/icon-menu2.png`" :text="$t('user.menu[1]')" to="/user/auditRecord" />
            <van-grid-item :icon="`./static/icon/${Theme}/icon-menu3.png`" :text="$t('user.menu[2]')" to="/user/postRecord" />
          </van-grid>
        </div> -->
        <div class="group">
          <div class="title">{{$t('user.title[1]')}}</div>
          <van-grid class="menu" :border="false" column-num="3" icon-size="30">
            <van-grid-item :icon="`./static/icon/${Theme}/icon-menu1.png`" :text="$t('user.menu[0]')" to="/user/taskOrder" />
            <van-grid-item :icon="`./static/icon/${Theme}/icon-menu13.png`" :text="$t('user.menu[12]')" to="/user/investOrder" />
            <!-- <van-grid-item v-if="InitData.setting.is_share==1" :icon="`./static/icon/${Theme}/icon-menu13.png`" :text="$t('Share[0]')" to="/share" /> -->
            <van-grid-item :icon="`./static/icon/${Theme}/icon-menu4.png`" :text="$t('user.menu[3]')" to="/user/info" />
            <!-- <van-grid-item :icon="`./static/icon/${Theme}/icon-menu5.png`" :text="$t('user.menu[4]')" to="/user/bindAccount" /> -->
            <van-grid-item :icon="`./static/icon/${Theme}/icon-menu6.png`" :text="$t('user.menu[5]')" to="/user/dayReport" />
            <van-grid-item :icon="`./static/icon/${Theme}/icon-menu7.png`" :text="$t('user.menu[6]')" to="/user/fundRecord" />
            
            <van-grid-item :icon="`./static/icon/${Theme}/icon-menu8.png`" :text="$t('user.menu[7]')" to="/user/promote" />
            <van-grid-item :icon="`./static/icon/${Theme}/icon-menu9.png`" :text="$t('user.menu[8]')" to="/user/teamReport" />
            <van-grid-item :icon="`./static/icon/${Theme}/icon-menu10.png`" :text="$t('user.menu[9]')" to="/serviceCenter" />
            <van-grid-item :icon="`./static/icon/${Theme}/icon-menu11.png`" :text="$t('serviceCenter[9]')" to="/serviceCenter/1" />
            <van-grid-item v-if="InitData.setting.is_coupon==1" :icon="`./static/icon/${Theme}/icon-menu14.png`" :text="$t('Coupon[0]')" to="/user/coupon" />
            <!-- <van-grid-item :icon="`./static/icon/${Theme}/icon-menu12.png`" :text="$t('user.menu[11]')" @click="goDown" /> -->
          </van-grid>
        </div>
      </div>
    </div>
    <Footer />
    <van-action-sheet v-model="showTheme" :title="$t('theme.title')">
      <van-grid class="ThemeList" :column-num="3">
        <van-grid-item v-for="item in themeList" :key="item" :icon="`./static/icon/${item}.png`" :text="$t('theme')[item]" @click="selectTheme(item)" />
      </van-grid>
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  name: 'User',
  components: {
  },
  props: [],
  data() {
    return {
      showTheme: false,
      themeList: themeList,
      showMoreTotal: false,
      showName: false,
    }
  },
 
  computed: {
    
  },
  watch: {

  },
  created() {
    this.$Model.GetUserInfo()
    this.$Model.GetStatisticsInfo()
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {

    selectTheme(color) {
      this.UpdateTheme(color)
      localStorage['Theme'] = color
      this.showTheme = false
    },
    goDown() {
      if(window.plus){
        this.$router.push('/AppDown')
      }else{
        this.$Util.OpenUrl(`${AppDown}?lan=${this.$i18n.locale}`)
      }
    }
  }
}
</script>
<style scoped>
.IndexBox{
  background-color: var(--background-assist);
}
.van-nav-bar>>>.van-nav-bar__left{
  font-size: 20px;
  font-weight: 600;
}
.UserInfo .top{
  background-color: var(--background-main);
  overflow: hidden;
}
.UserInfo .info .head{
  margin-right: 15px;
  border-radius: 100%;
  border:2px #e6e5e8 solid;
}
.UserInfo .info .van-cell__title{
  font-size: 20px;
}
.UserInfo .info .van-cell__title span{
  background-color: #3e3e3e;
  color: #ffe2b7;
  font-size: 12px;
  padding: 3px 5px;
  border-radius: 3px;
  margin-left: 10px;
}
.UserInfo .info .van-cell__value{
  flex: none;
  line-height: 1.3;
}
.UserInfo .info .van-cell__value a{
  text-align: center;
  display: block;
}
.UserInfo .info .van-cell__label{
  line-height: 1;
  margin-top: 6px;
}
.UserInfo .info .van-cell__label p{
  margin-top: 5px;
}
.UserInfo .money{
  padding: 0 16px;
  position: relative;
  z-index: 2;
  width: 100%;
}
.UserInfo .money::before{
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: -50%;
}
.UserInfo .money>div{
  border-radius: 5px;
  box-shadow: 0 2px 5px #888;
  overflow: hidden;
  width: 100%;
  position: relative;
  z-index: 2;
  padding: 0 5px;
}
.UserInfo .money .van-steps{
  padding: 8px 16px 0;
}
.UserInfo .money .van-steps>>>.van-step__title{
  font-size: 14px;
}
.UserInfo .money .van-cell__title em{
  font-size: 22px;
}
.ThemeList>>>.van-grid-item__content{
  justify-content: flex-start;
  text-align: center;
}
.steps{
  padding: 10px 20px;
}
.steps .bg{
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 6px;
}
.steps .bg i{
  width: 6px;
  height: 6px;
  background-color: #d1d1d1;
  border-radius: 100%;
  position: relative;
  z-index: 3;
}
.steps .bg i.active:nth-child(1){
  background-color: #f83b3a;
}
.steps .bg i.active:nth-child(2){
  background-color: #fba646;
}
.steps .bg i.active:nth-child(3){
  background-color: #b7b67e;
}
.steps.step1 .bg i.active:nth-child(2),.steps.step2 .bg i.active:nth-child(3),.steps .bg i.active:nth-child(4){
  background-color: #2bd6ef;
}
.steps .bg:after,.steps .bg .portion{
  content: '';
  display: block;
  width: 100%;
  height: 2px;
  background-color: #d1d1d1;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  margin-top: -1px;
}
.steps .bg .portion{
  width: 15%;
  background: linear-gradient(to right,#f83b3a,#fba646,#2bd6ef);
  z-index: 2;
}
.steps.step1 .portion{
  width: 33.33%;
}
.steps.step2 .portion{
  width: 66.66%;
}
.steps.step3 .portion{
  width: 100%;
}
.steps .mark{
  background-color: #2fd5eb;
  display: inline-block;
  color: #fff;
  font-size: 12px;
  padding: 3px 6px;
  line-height: 1;
  border-radius: 50px;
  position: relative;
  max-width: 44px;
  text-align: center;
  transform: translateX(-42%);
  left: 0;
}
.steps.step1 .mark{
  left: 33.33%;
  transform: translateX(-48%);
}
.steps.step2 .mark{
  left: 66.66%;
  transform: translateX(-52%);
}
.steps.step3 .mark{
  left: 100%;
  transform: translateX(-57%);
}
.steps .mark:after{
  content: '';
  border: 5px solid transparent;
  border-top-color: #2fd5eb;
  position: absolute;
  bottom: -9px;
  left: 50%;
  margin-left: -5px;
}
.user-balance {
  margin: 10px 20px 15px;
  color: #fff;
  line-height: 1;
  position: relative;
}
.user-balance .bg{
  background-image: url('../../../public/static/images/default/task_bg.png'),linear-gradient(to right,#f83a3a,#fba030);
  background-repeat: no-repeat;
  background-size: 100%;
  padding: 20px 15px;
  border-radius: 10px 10px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
}
.user-balance .left{
  font-size: 24px;
}
.user-balance .left p{
  font-size: 12px;
  margin-bottom: 8px;
}
.user-balance .line{
  height: 6px;
  background-color: #d1d1d1;
  border-radius: 10px;
  position: absolute;
  left: -5px;
  right: -5px;
  bottom: -2px;
}
.total {
  background-color: #fafafa;
  border-radius: 10px;
  overflow: hidden;
}
.total .top>>>.van-grid-item__content{
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
  justify-content: space-between;
}
.total .top>>>.van-grid-item__content::after{
  content: '';
  position: absolute;
  right: 0;
  top: 16px;
  bottom: 16px;
  border-right: 1px solid var(--border-color-main);
}
.total .top>>>.van-grid-item__icon-wrapper{
  font-size: 12px;
  color: var(--color-assist);
  font-weight: 400;
  margin-bottom: 10px;
  text-align: center;
}
.total .more{
  background-color: var(--background-main);
  text-align: center;
  line-height: 1;
  padding-bottom: 6px;
  display: block;
}
.total .bottom{
  width: 100%;
  border-top: 1px solid var(--border-color-main);
  background-color: #fafafa;
  text-align: center;
  padding: 0 5px;
}
.total .bottom thead{
  font-size: 12px;
  color: var(--color-assist);
}
.total .bottom thead td{
  padding: 5px 0;
}
.total .bottom tbody td{
  padding: 8px 5px;
  border-bottom: 1px #f0f0f0 solid;
}
.total .bottom tbody td:first-child{
  text-align: left;
}
.total .bottom tbody td b{
  color: var(--color-important);
  font-size: 15px;
}
.total .bottom>>>.van-grid-item__content{
  background-color: transparent;
  padding: 5px 15px;
  font-size: 15px;
  line-height: 1;
  color: var(--color-important);
  justify-content: space-between;
}
.total .bottom>>>.van-grid-item__icon-wrapper{
  font-size: 12px;
  color: var(--color-main);
  margin-right: 5px;
}
.group{
  margin-top: 15px;
  background-color: var(--background-main);
  border-radius: 10px;
  overflow: hidden;
  line-height: 1;
}
.group .title{
  padding: 15px 15px 0;
  font-size: 16px;
  font-weight: 600;
}
.menu{
  padding: 5px 0;
}
.menu>>>.van-grid-item__content{
  justify-content: flex-start;
  text-align: center;
}
</style>